import { render, staticRenderFns } from "./ReportInfoTable.vue?vue&type=template&id=a6d53cb8&scoped=true&"
import script from "./ReportInfoTable.vue?vue&type=script&lang=ts&"
export * from "./ReportInfoTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d53cb8",
  null
  
)

export default component.exports